import Locations from '~/components/elements/locations/Locations'
import type { Page_Flexcontent_Flex_Locations } from '~/graphql/types'

export default function LocationsRegion({ fields }: { fields: Page_Flexcontent_Flex_Locations }) {
  return <Locations search={false} fields={fields} />
}
